module.exports = __webpack_public_path__ + "img/rules.3b299150.png";